import constants from '@/app-configs/constants'

export default [
  {
    path: '/smsresponselogs',
    name: 'smsresponselogs',
    component: () => import('@/views/smsresponselogs/Logs.vue'),
    meta: {
      pageTitle: 'DEBTIA_FAILED_SMS_RESPONSE_LOGS',
      breadcrumb: [
        {
          text: 'DEBTIA_FAILED_SMS_RESPONSE_LOGS',
          active: true,
        },
      ],
      action: constants.action.permissionFailedSmsResponseLogsList,
      resource: constants.resource.smsresponselogs,
    },
  },
]
